/**
 * Product Description Route
 */
import React, { useLayoutEffect } from 'react';
import Layout from '@/components/Layout';
import ProductDescription from '../../../containers/ProductDescription';
import { getCatalogItemById } from '../../../services';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import { _404Redirect } from '@/utils/404Redirect';
import { useSetSSRStore, useSSRSelector } from '../../../redux';
import { getSSRStoreData } from '../../../utils/ssrPageData';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';

const ProductDescPage = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout
      store={storeInfo}
      title={
        props?.advCustomSeoDetails?.title?.value
          ? props?.advCustomSeoDetails?.title?.value
          : `Order ${props?.product.name} Online From ${storeInfo?.store_info?.name}${
              storeInfo?.address?.visibility === 1 && storeInfo.address?.city
                ? `,${storeInfo.address?.city}`
                : ``
            }`
      }
      OGTitle={props?.advCustomSeoDetails?.og_title?.value || null}
      OGDescription={props?.advCustomSeoDetails?.og_description || null}
      Icon={props?.product?.thumbnail_url}
      metaDescription={
        props?.advCustomSeoDetails?.description
          ? props?.advCustomSeoDetails?.description
          : `Order Online ${props?.product?.name} for Rs.${props?.product?.price}. Shop from ${storeInfo?.store_info?.name},${storeInfo.address?.city} | ${props?.product.description}`
      }
      isCustomDomain={props.isCustomDomain}
      {...props}
    >
      <ProductDescription {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};
  const { pid } = ctx.query;
  let propData = {
    product: {},
    catalogCategories: [],
    isCustomDomain: false,
    catalogTags: [],
    collections: [],
  };
  // to check only for number string
  const regExp = /[a-zA-Z]/g;
  if (regExp.test(pid)) {
    ctx.res.writeHead(302, { location: '/404' });
    return;
  }

  const propType = await getSSRStoreData(ctx, {
    additionalDataToFetch: ['collections', 'categories', 'advancedSeo'],
    advancedSeoReqConfigs: {
      type: 'item',
      typeId: pid,
    },
  });

  const storeId = propType?.ssrStore?.storeReducer?.store?.store_id;

  if (!storeId) {
    _404Redirect(ctx);
    ctx.res.end();
    return { props: {} };
  }

  const productResponse = await getCatalogItemById(storeId, pid, 'product_pid_ssr');

  if (productResponse.data && productResponse.data.status) {
    const productItem = JSON.parse(productResponse?.data?.data);
    propData.product = productItem;
  } else {
    _404Redirect(ctx);
    ctx.res.end();
    return;
  }

  const extraProps = getRequiredCtxProps(ctx, propType);

  propData = { ...propData, ...propType };

  return { props: { ...propData, ...extraProps } };
}

export default ProductDescPage;
